import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectDepositAccountPaymentId,
  selectDepositAccountProvider,
  selectIsRecommendedPackagePaymentStatusCheckInProgress,
  selectRecommendedPackagePaymentStatus,
} from '../../../../../../../selectors/depositAccount';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';
import { updateDepositAccountRecommendedPackagePaymentStatus } from '../../../../../../../actions/depositAccount';
import { checkPaymentStatus } from '../../../../../../../thunks/payment/checkPaymentStatus';

export const useRecommendedPackagesPaymentStatus = () => {
  const dispatch = useDispatch();

  const isRender = useSelector(selectIsRecommendedPackagePaymentStatusCheckInProgress);
  const paymentId = useSelector(selectDepositAccountPaymentId);
  const provider = useSelector(selectDepositAccountProvider);
  const isMobile = useSelector(selectIsMobileLayout);
  const status = useSelector(selectRecommendedPackagePaymentStatus);

  const handleRetryClick = useCallback(() => {
    if (paymentId && provider) {
      dispatch(
        checkPaymentStatus({
          setStatusAction: updateDepositAccountRecommendedPackagePaymentStatus,
          paymentId,
          provider,
        }),
      );
    }
  }, [dispatch, paymentId, provider]);

  return { isRender, isMobile, status, handleRetryClick };
};
